import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles({
  index: {
    borderRight: "3px solid #eeeeee",
    "& a": {
      textDecoration: "none",
      color: "#333333",
      "&:hover": {
        textDecoration: "none",
        color: "#666666",
      },
      "&.current": {
        color: "#26a69a",
        fontWeight: 400,
        borderRight: "3px solid #26a69a",
        marginRight: "-23px",
        paddingRight: "20px",
      },
    },
  },
  apiDocs: {
    fontSize: 18,
    "& * .MuiTab-root": {
      minWidth: 0,
      marginRight: 0,
      "& * code": {
        border: "1px solid",
        padding: "4px 10px",
        borderRadius: 3,
        backgroundColor: "#eee",
        fontSize: "smaller",
      },
    },
    "& * code": {
      fontSize: "smaller",
    },
    "& * .attribute": {
      paddingTop: 16,
      "& .name": {
        color: "#333",
        fontFamily: "monospace",
        fontSize: "12pt",
        fontWeight: 600,
        wordWrap: "break-word",
      },
      "& .type": {
        color: "#598CED",
        fontSize: "11pt",
        fontWeight: 500,
      },
      "& .tip": {
        cursor: "context-menu",
        borderBottom: "1px dashed #666666",
      },
      "& .description": {
        fontSize: "12pt",
        marginTop: "4px",
      },
    },
    "& * .example-json": {
      "& .MuiPaper-root": {
        backgroundColor: "#eee",
        paddingRight: 0,
        padding: "20px",
        marginTop: "80px",
      },
      "& pre": {
        margin: 0,
      },
      "& hr": {
        marginRight: "20px",
      },
      "& code": {
        border: "none",
        fontSize: "small",
        lineHeight: 1.1,
        backgroundColor: "#eee",
      },
      "& .json-content": {
        overflowY: "auto",
        maxHeight: "30em",
      },
    },
  },
});
